(function() {
    'use strict'; 
    angular.module('app').controller('NotificationModalController', NotificationModalController);
    
    NotificationModalController.$inject = [
        '$uibModalInstance',
        'title',
        'message'
    ];

    function NotificationModalController(
        $uibModalInstance,
        title,
        message
    ) {
        const vm = this;
        vm.closeModal = closeModal;
        
        init();

        function init() {
            vm.title = title; 
            vm.message = message;
        }

        function closeModal() {
            $uibModalInstance.dismiss();
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/modal/NotificationModalController.js